"use strict";

class SuperAdminNotificationsController {
    constructor($scope, SSHttpService, SSUtilService, SSDateService, SSAwsService, SSAppService, SSConfigService, SSUserService, SSAlertService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAwsService = SSAwsService;
        self.SSAppService = SSAppService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;

        self.CMS_CATEGORIES_MAP = SHOWSUITE.CMS_CATEGORIES_MAP;
        self.CMS_CATEGORY_JOBS = SHOWSUITE.CMS_CATEGORY_JOBS;
        self.CMS_CATEGORY_PRESS = SHOWSUITE.CMS_CATEGORY_PRESS;
        self.CMS_CATEGORY_SEARCH_GROUPS = SHOWSUITE.CMS_CATEGORY_SEARCH_GROUPS;
        self.CMS_CATEGORY_FEATURED = SHOWSUITE.CATEGORY_FEATURED;

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.category = null;
        self.updateCmsContainerVar = false;
        self.showAllowedTags = false;
        self.selectedtitle = '';
        self.errTitle = '';
        self.errContent = '';
        self.errCatId = '';
        self.showNotificationForm = false;

        self.filters = {
            group: 0,
            type: 0,
            user_category: 0,
            title: '',
            offset: 0,
            limit: 10,
            send_total_count: 1
        };
        self.filtersPost = {
            offset: 0,
            limit: 10,
        };
        self.pageNo = 1;
        self.current = 1;


        self.categories = {
            10: {id: 10, value: "All Users"},
            20: {id: 20, value: "All Developers"},
            30: {id: 30, value: "All Agencies"},
            40: {id: 40, value: "All Brokers"},
            50: {id: 50, value: "All Buyers"},
            60: {id: 60, value: "Private, for only one user"},
        };
        self.catSelected = null;

        self.get(1);

    }

    get(page) {
        let self = this;

        self.notifications = null;

        if(page) {
            self.current = page;
        }


        self.filters['offset'] = (page * self.filters['limit']) - self.filters['limit'];

        loading(true);
        self.SSHttpService.getAPIRequest('sec/super/notifications/get', self.filters).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.notifications = response.data.notifications;

            self.total_count = response.data.total_count;

            console.log('new Data');
            console.log(response.data);

            self.prepareNotificationsPaginationData();

        });
    }

    toggleEditContainer() {
        const self = this;

        self.showNotificationForm = !self.showNotificationForm;

        if (self.showNotificationForm)
            angular.element('#notificationEditContainer').modal('show');
        if ($('#notificationEditContainer').is(':visible'))
            $('#notificationEditContainer').modal('hide');
    }

    open(notification) {
        const self = this;

        self.notification = {};

        if (notification) {
            self.notification = angular.copy(notification);
        }

        self.errTitle = '';
        self.errGroup = '';
        self.errType = '';
        self.errCategory = '';
        self.errUser = '';
        self.errContent = '';

        self.toggleEditContainer();
    }

    togglePrivateUser(catType) {
        const self = this;

        self.catSelected = catType;
    }

    post() {
        const self = this;

        self.filtersPost['limit'] = self.filters['limit'];
        if (!self.validate()) return;

        angular.merge(self.notification, self.filtersPost);

        let url = 'sec/super/notifications/post';

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.notification).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Saved successfully.');

            let notification = response.data.notification;

            let found = false;
            jQuery.each(self.notifications, function (i, _notification) {
                if (_notification.id == notification.id) {
                    angular.merge(_notification, notification);
                    found = true;
                    return false;
                }
            });

            if (!found) {
                self.notifications.push(notification);
            }
            self.showNotificationForm = false;
            self.toggleEditContainer();
        });
    }

    validate() {
        const self = this;

        let error = false;

        self.errTitle = '';
        self.errGroup = '';
        self.errType = '';
        self.errCategory = '';
        self.errUser = '';
        self.errContent = '';

        if (!self.notification.title) {
            self.errTitle = 'Notification title is required';
            error = true;
        }
        if (!self.notification.group) {
            self.errGroup = 'Notification group is required';
            error = true;
        }

        if (!self.notification.type) {
            self.errType = 'Notification type is required';
            error = true;
        }

        if (!self.notification.user_category) {
            self.errCategory = 'Notification category is required';
            error = true;
        }

        if (self.notification.user_category == '5' && !self.notification.user_id) {
            self.errUser = 'Notification user is required';
            error = true;
        }

        if (!self.notification.contents) {
            self.errContent = 'Notification contents are required';
            error = true;
        }

        return !error;
    }

    remove(notification) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this entry?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let url = 'sec/super/notifications/'+notification.id+'/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.SSAlertService.success('Notification deleted successfully.');

                    jQuery.each(self.notifications, function (i, _notification) {
                        if (_notification.id == notification.id) {
                            self.notifications.splice(i, 1);
                            return false;
                        }
                    });
                });
            }
        );
    }

    showAllowedTag() {
        const self = this;

        self.showAllowedTags = (self.showAllowedTags == false) ? true : false;
    }

    upload(file) {
        const self = this;

        let url = 'super/cms/' + self.category + '/s3-policy-document';

        loading(true);
        self.SSAwsService.upload(file, url, function (response) {
            loading(false);

            self.notification.file_uri = response.config.data.key;
        });
    }

    getContentsPlaceholder() {
        const self = this;

        let placeholder = '';
        if (self.category == self.CMS_CATEGORY_SEARCH_GROUPS || self.category == self.CMS_CATEGORY_FEATURED) {
            placeholder = 'URL';
        } else if (self.category == self.CMS_CATEGORY_SEARCH_GROUPS || self.category == self.CMS_CATEGORY_FEATURED) {
            placeholder = 'Contents';
        }

        return placeholder;
    }

    updateRowLimit(){
        const self = this;

        self.filters['offset'] = 0;
        self.get(1);
    }
    prepareNotificationsPaginationData() {
        const self = this;

        self.total_count  = Math.ceil(self.total_count / self.filters['limit']);

        self.brokerPagesArrayDisplay = [];
        self.brokerPagesArray = [];

        for (let i = 0; i < self.total_count; i++) {
            self.brokerPagesArray.push(i + 1);
        }

        for (let i = self.pageNo - 3; i <= self.pageNo ; i++) {
            if(i <= 0 )
                continue;
            self.brokerPagesArrayDisplay.push(i);
        }

        for (let j = self.pageNo + 1; j <= self.pageNo + 3; j++) {
            if(j > self.total_count)
                break;
            self.brokerPagesArrayDisplay.push(j);
        }

        if (self.total_count < self.pageNo) {
            self.pageNo = 1;
        }

    }

    setPageNonotifications(pageNo) {
        const self = this;

        if (pageNo) {
            if (pageNo == 'next') {
                pageNo = self.pageNo + 1;
            } else if (pageNo == 'previous') {
                pageNo = self.pageNo - 1;
            }

            if (pageNo > self.total_count) {
                pageNo = self.total_count;
            } else if (pageNo < 1) {
                pageNo = 1;
            }

            if (pageNo == self.pageNo) {
                return; // Ignore if no change
            }

            self.pageNo = pageNo;
        }

        self.filters['offset'] = (self.pageNo - 1) * self.filters['limit'];

        self.get(self.pageNo);
    }
    clearFilters(){
        const self = this;
        self.filters['type'] = 0;
        self.filters['group'] = 0;
        self.filters['user_category'] = 0;
        self.filters['title'] = '';
        self.get(1);
    }

}

SuperAdminNotificationsController.$inject = ['$scope', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAwsService', 'SSAppService', 'SSConfigService', 'SSUserService', 'SSAlertService', 'SSConfirmationService'];
app.controller('SuperAdminNotificationsController', SuperAdminNotificationsController);

